import { useEffect } from 'react';

import { useCoreDispatch } from '../../../store/CoreStore';
import { useBetSlice } from '../../../store/slices/bets/selectors';
import { useBonusPromotionsSlice } from '../../../store/slices/bonusPromotions/selectors';
import { useConfigSlice } from '../../../store/slices/config/selectors';
import { useGameStateSlice } from '../../../store/slices/game/selectors';
import { popupActions } from '../../../store/slices/popup/slice';
import { PopupType } from '../types';

export const useInsufficientFundsDispatcher = (isCurtainVisible: boolean): void => {
  const isLowBalance = useBetSlice.isLowBalance();
  const isBetsOpenStatus = useGameStateSlice.isBetsOpenStatus();
  const hasTotalBet = useBetSlice.hasTotalBet();
  const tableConfig = useConfigSlice.tableConfig();
  const userInfoReady = useGameStateSlice.userInfoReady();
  const isBonusInitialised = useBonusPromotionsSlice.getIsBonusPromotionsInitialised();

  const dispatch = useCoreDispatch();

  useEffect(() => {
    if (!userInfoReady || !tableConfig || isCurtainVisible) return;
    if (!isBonusInitialised) return;

    /**
     * Display low balance popup on load if balance is not available
     * or is less than min bet size and bets are open and total placed bet is 0.
     */
    if (isLowBalance && isBetsOpenStatus && !hasTotalBet) {
      dispatch(popupActions.pushPopup(PopupType.InsufficientFunds));
    }
  }, [
    dispatch,
    hasTotalBet,
    isBetsOpenStatus,
    isLowBalance,
    tableConfig,
    userInfoReady,
    isBonusInitialised,
    isCurtainVisible,
  ]);
};
